import React, { useEffect, useRef, useState } from "react";
import { isValidEmail } from "../../lib/validation";

export function EmailInput({ value, onChange }) {
    const [local, setLocal] = useState(value ?? "");
    const [touched, setTouched] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        setLocal(value ?? "");
    }, [value]);

    function handleChange(e) {
        const next = e.target.value;
        setLocal(next);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => onChange(next.trim()), 300);
    }

    const invalid = touched && local && !isValidEmail(local);

    return (
        <div data-testid="email-input">
            <input
                type="email"
                autoComplete="email"
                inputMode="email"
                value={local}
                onChange={handleChange}
                onBlur={() => setTouched(true)}
                placeholder="you@example.com"
                aria-label="Email address"
                aria-invalid={invalid ? "true" : "false"}
                className={`w-full p-5 rounded-2xl border bg-klareet-card text-klareet-TEXT placeholder:text-klareet-DIM outline-none transition-colors duration-200
                    ${
                        invalid
                            ? "border-klareet-RED focus:border-klareet-RED focus:ring-2 focus:ring-klareet-RED/40"
                            : "border-klareet-bor focus:border-klareet-T focus:ring-2 focus:ring-klareet-T/40"
                    }`}
            />
            <div className="mt-2 text-xs font-mono text-klareet-MUT">
                {invalid
                    ? "That email looks off. Want to try again?"
                    : "Optional · we hate spam too."}
            </div>
        </div>
    );
}
